import { gql } from '@apollo/client';

export default class CompanyQuery {
    static GET_COMPANY = gql`
        query getCompany {
            getCompany {
                companyCode
                companyDbName
                companyName
                companyAddress
                companyCity
                companyState
                companyZip
                companyCountry
                companyPhone
                companyFax
                companyWebsite
                companyContact
                companyEin
                companyEmail
                carfaxId
                secureCloseDmsguid
                secureCloseEnabled
                companyTimeZoneId
                companyTimezone
                companyLogo
                plaidClientId
                plaidSecretKey
                companyStateRtAccount
            }
        }
    `;

    static GET_COMPANY_THEME = gql`
        query getCompanyTheme {
            getCompanyTheme {
                key
                value
                companySettingId
            }
        }
    `;

    static GET_COMPANY_CARFAX = gql`
    query getCompanyCarfax {
        getCompanyCarfax {
            value
        }
    }
    `;

    static GET_PAYMENT_PROVIDER = gql`
        query getPaymentProvider {
            getPaymentProvider{
                value
                category
            }
        }
    `;

    static GET_COMPANY_SETTINGS = gql`
        query getCompanySettings($category: String, $key: [String]){
            getCompanySettings(category: $category, key: $key) {
                category
                key
                value
            }
        }
    `;
}
